import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 25,
    seconds: 0
  });
  useEffect(() => {
    const DURATION = 3 * 60 * 60 * 1000 + 25 * 60 * 1000; // 3 hours 25 minutes in ms
    const STORAGE_KEY = 'clave_de_paz_timer_start';
    const initTimer = () => {
      let startTime = localStorage.getItem(STORAGE_KEY);
      if (!startTime) {
        startTime = Date.now().toString();
        localStorage.setItem(STORAGE_KEY, startTime);
      }
      return startTime;
    };
    let startTime = initTimer();
    const calculateTimeLeft = () => {
      const now = Date.now();
      const elapsed = now - parseInt(startTime!);
      const remaining = Math.max(0, DURATION - elapsed);
      if (remaining === 0) {
        // Reset timer
        localStorage.removeItem(STORAGE_KEY);
        startTime = Date.now().toString();
        localStorage.setItem(STORAGE_KEY, startTime);
        return {
          hours: 3,
          minutes: 25,
          seconds: 0
        };
      }
      return {
        hours: Math.floor(remaining / (1000 * 60 * 60) % 24),
        minutes: Math.floor(remaining / 1000 / 60 % 60),
        seconds: Math.floor(remaining / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (compact) {
    return <div className="flex items-center gap-1 font-mono font-bold bg-black/20 px-2 py-1 rounded text-white" data-id="element-41">
        <span data-id="element-42">{formatNumber(timeLeft.hours)}</span>:
        <span data-id="element-43">{formatNumber(timeLeft.minutes)}</span>:
        <span data-id="element-44">{formatNumber(timeLeft.seconds)}</span>
      </div>;
  }
  return <div className="flex justify-center gap-3 my-6" data-id="element-45">
      <div className="flex flex-col items-center" data-id="element-46">
        <div className="bg-slate-900 text-white font-mono text-3xl md:text-4xl font-bold py-3 px-4 rounded-lg shadow-inner border border-slate-700 w-16 md:w-20 flex justify-center" data-id="element-47">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs text-slate-500 font-bold uppercase mt-2" data-id="element-48">
          Horas
        </span>
      </div>
      <div className="text-3xl md:text-4xl font-bold text-slate-400 mt-2" data-id="element-49">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-50">
        <div className="bg-slate-900 text-white font-mono text-3xl md:text-4xl font-bold py-3 px-4 rounded-lg shadow-inner border border-slate-700 w-16 md:w-20 flex justify-center" data-id="element-51">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs text-slate-500 font-bold uppercase mt-2" data-id="element-52">
          Min
        </span>
      </div>
      <div className="text-3xl md:text-4xl font-bold text-slate-400 mt-2" data-id="element-53">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-54">
        <div className="bg-red-600 text-white font-mono text-3xl md:text-4xl font-bold py-3 px-4 rounded-lg shadow-inner border border-red-700 w-16 md:w-20 flex justify-center" data-id="element-55">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs text-red-600 font-bold uppercase mt-2" data-id="element-56">
          Seg
        </span>
      </div>
    </div>;
}